import type React from "react";
import type { ValidationError } from "class-validator";
import classes from "../classes.module.scss";
import StepEmailClientSection from "./StepEmailClientSection";
import type { StepEmailSiteTexts } from "../hooks/useStepEmailSiteTexts";

type Props = {
	siteTexts: StepEmailSiteTexts;
	onSubmit: (e: React.FormEvent<HTMLFormElement> | null, values: { [key: string]: string }) => void;
	validationErrors: ValidationError[];
	prefilledEmail: string;
};

/**
 * Client column only — notary IdNot block is rendered above the welcome subtitle in StepEmailPanelsContent.
 */
function StepEmailPanelsInnerView(props: Props): React.JSX.Element {
	const { siteTexts, onSubmit, validationErrors, prefilledEmail } = props;
	return (
		<div className={classes["content"]}>
			<StepEmailClientSection
				title={siteTexts.clientsSectionTitleDisplay}
				onSubmit={onSubmit}
				validationErrors={validationErrors}
				prefilledEmail={prefilledEmail}
				emailPlaceholder={siteTexts.emailPlaceholderDisplay}
				submitCta={siteTexts.submitCtaDisplay}
			/>
		</div>
	);
}

export default function StepEmailPanelsInner(props: Props): React.JSX.Element {
	return <StepEmailPanelsInnerView {...props} />;
}
